import _styled from "@emotion/styled-base";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from "react";
import { css } from "@emotion/core";
import { color, space, typography } from "styled-system";
import shouldForwardProp from "@styled-system/should-forward-prop";
import { textTransform } from "./css";

function createHeadingComponent(tier, displayName, defaultStyles) {
  var StyledHeading =
  /*#__PURE__*/
  _styled(tier, {
    shouldForwardProp: shouldForwardProp,
    target: "eywvwkv0"
  })(function (_ref) {
    var theme = _ref.theme;
    return (
      /*#__PURE__*/
      css("label:base;font-family:", theme.fonts.heading, ";font-weight:normal;line-height:", theme.lineHeights.heading, ";margin:0;color:", theme.colors.heading, ";")
    );
  }, defaultStyles, color, space, textTransform, typography);

  StyledHeading.displayName = displayName;
  return StyledHeading;
}

export var Heading1 = createHeadingComponent("h1", "Heading1", function (_ref2) {
  var theme = _ref2.theme;
  return (
    /*#__PURE__*/
    css("label:h1;font-size:", theme.fontSizes.xxl, ";")
  );
});
export var Heading2 = createHeadingComponent("h2", "Heading2", function (_ref3) {
  var theme = _ref3.theme;
  return (
    /*#__PURE__*/
    css("label:h2;font-size:", theme.fontSizes.xl, ";")
  );
});
export var Heading3 = createHeadingComponent("h3", "Heading3", function (_ref4) {
  var theme = _ref4.theme;
  return (
    /*#__PURE__*/
    css("label:h3;font-size:", theme.fontSizes.lg, ";")
  );
});
export var Heading4 = createHeadingComponent("h4", "Heading4", function (_ref5) {
  var theme = _ref5.theme;
  return (
    /*#__PURE__*/
    css("label:h4;font-size:", theme.fontSizes.md, ";")
  );
});
export var Heading5 = createHeadingComponent("h5", "Heading5", function (_ref6) {
  var theme = _ref6.theme;
  return (
    /*#__PURE__*/
    css("label:h5;font-size:", theme.fontSizes.sm, ";")
  );
});
export var Heading6 = createHeadingComponent("h6", "Heading6", function (_ref7) {
  var theme = _ref7.theme;
  return (
    /*#__PURE__*/
    css("label:h6;font-size:", theme.fontSizes.xs, ";")
  );
});
var headingTierMapping = {
  h1: Heading1,
  h2: Heading2,
  h3: Heading3,
  h4: Heading4,
  h5: Heading5,
  h6: Heading6
};

var Heading =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Heading, _React$Component);

  function Heading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Heading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        tier = _this$props.tier,
        props = _objectWithoutPropertiesLoose(_this$props, ["tier"]);

    var HeadingElement = headingTierMapping[tier] || Heading2;
    return ___EmotionJSX(HeadingElement, props);
  };

  return Heading;
}(React.Component);

_defineProperty(Heading, "defaultProps", {
  tier: "h2"
});

export { Heading as default };